// カテゴリー色選択情報
export const COLOR_PALETTE: string[] = [ "red", "pink", "purple", "bluepurple", "blue", "lightblue", "green", "yellowgreen", "matchabrown", "brightyellow", "tangerine", "orange"];
export const DEFAULT_COLOR: string = "bluepurple";

export const column = 3;
export const row = 4;